import { useAuth } from 'auth'
import { useEffectOnce } from 'react-use'
import InviteMemberLogin from 'views/InviteMemberLogin'
import useIdentityProviders from 'hooks/useIdentityProviders'
import useQueryParam from 'hooks/useQueryParam'
import { useGetWorkspaceAdminInviteDetails } from 'api/endpoints/portalAdmins'
import { LoadingScreen } from 'components/Loading'
import { Box } from '@ritualco/jutsu'
import { useAnalytics } from 'lib/simple-analytics'

const InviteMemberLoginContainer = () => {
  const { createLoginUrl, createRegisterUrl } = useAuth()
  const { providers } = useIdentityProviders()
  const queryParams = useQueryParam()
  const accessCode = queryParams.get('accessCode')
  const { track, page } = useAnalytics()
  const workspaceInvite = useGetWorkspaceAdminInviteDetails({
    invitationId: accessCode as string,
  })

  useEffectOnce(() => {
    page()
  })

  if (!workspaceInvite.data) {
    return <LoadingScreen />
  }

  const { inviterOrganizationName = '' } = workspaceInvite.data

  return (
    <Box height="100vh">
      <InviteMemberLogin
        identityProviders={providers}
        onLogin={provider => {
          track('PORTAL_LOGIN_CLICK', {
            identity_provider: provider.id,
          })
          window.location.href = createLoginUrl({
            idpHint: provider.id || 'email',
            redirectUri: window.location.href,
          })
        }}
        onRegister={() => {
          window.location.href = createRegisterUrl({
            redirectUri: window.location.href,
          })
        }}
        organizationName={inviterOrganizationName}
      />
    </Box>
  )
}

export default InviteMemberLoginContainer
